<template>
  <div style="height:100%">
    <div class="addNewClass" v-if="showAddnotice == false && showEditlabel == false">
      <div class="content">
        <div class="operation">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-button type="primary" :round="false" size="small" icon="el-icon-plus" @click="goAddnotice">
                  <span>添加公告</span>
                </el-button>
              </div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="grid-content bg-purple seach">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link" style="margin-right:10px">
                    状态
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>启用</el-dropdown-item>
                    <el-dropdown-item>禁用</el-dropdown-item>
                    <el-dropdown-item>删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input placeholder="请输入内容" v-model="screenInput" clearable size="small"></el-input>
                <el-button type="primary" size="small" @click="screen">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="tableoperation"></div> -->
        <template>
          <el-table 
            ref="multipleTable" 
            :data="tableData" 
            tooltip-effect="dark" 
            style="width: 100%"
            v-loading="loading"
            element-loading-text="拼命加载中" 
            @selection-change="handleSelectionChange">
            <el-table-column>
              <template slot="header">
                <div class="lft">
                  <el-button size="mini" @click="startUse(1)">启用</el-button>
                  <el-button size="mini" @click="startUse(0)">禁用</el-button>
                  <el-button size="mini" @click="deletes">删除</el-button>
                </div>
                <div style="float:right">
                  <span>共{{ tableData.length }}条记录</span>
                </div>
              </template>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="logo" min-width="200">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.logo"
                    fit="cover">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column label="标题" min-width="200">
                <template slot-scope="scope">{{ scope.row.title }}</template>
              </el-table-column>
              <el-table-column label="小程序链接" min-width="200">
                <template slot-scope="scope">{{ scope.row.wapp_url }}</template>
              </el-table-column>
              <el-table-column label="公众号链接" min-width="200">
                <template slot-scope="scope">{{ scope.row.wechat_url }}</template>
              </el-table-column>
              <el-table-column label="创建时间" min-width="200">
                <template slot-scope="scope">{{ scope.row.create_time }}</template>
              </el-table-column>
              <el-table-column label="状态" width="120">
                <template slot-scope="scope">
                  <!-- <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  type="primary"
                  >启用</el-button>-->
                  <div class="stats" v-if="scope.row.status == 1">启用</div>
                  <div class="stats" v-else style="background:#acbcda">
                    禁用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"></el-button>
                  <el-button size="mini" @click="handledelet(scope.$index, scope.row)" icon="el-icon-delete"></el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </template>
        <div class="block paging">
          <el-pagination
            layout="prev, pager, next"
            :total="50">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addNotice from "@/components/system/addNotice.vue";
import editLabelgroup from "@/components/commodity/editAnnouncement.vue";
import { AdList, delAdList } from "@/api/announcement";
export default {
  components: {
    addNotice,
    editLabelgroup
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      showAddnotice: false,
      showEditlabel: false,
      idx: 1,
      loading: true,
      screenInput: "",
      nowIDx: 0,
      nowdata: {},
      value: "",
      input: "",
      radio: "",
      page: 1,
      tableData: [],
      multipleSelection: [],
    };
  },
  mounted() {
      // 获取列表
    this.getGoodsList();
    setTimeout(() => {
      this.loading = false;
    }, 800)
  },
  methods: {
    goAddnotice() {
      console.log('aaaa');
      this.$router.push('addnotice');
    },
    // 获取商品列表
    getGoodsList() {
      let data = {
        "token": this.token,
        "store_id": 2,
        "page": this.page,
      }
      AdList(data).then((res) => {
        if (res.code == 1) {
          if (res.data.length > 0) {
            this.tableData = res.data;
          } else {
            this.$message("暂无数据");
          }
        } else {
          this.$message(res.msg);
        }
        console.log(res);
      })
    },
    // 筛选
    screen() {
      if (this.screenInput == "") {
        this.$message("输入不许为空");
      } else {
        console.log(111);
        let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: this.merch_id,
          name: this.screenInput
        };
        labelList(data).then(res => {
          console.log(res);
          this.tableData = res.data;
        });
      }
    },
    deletes() {
      // 多选删除
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择后操作",
          type: "warning"
        });
      } else {
        let data = {};
        let arrid = [];
        for (const item in this.multipleSelection) {
          if (this.multipleSelection.hasOwnProperty(item)) {
            const element = this.multipleSelection[item].id;
            arrid.push(element);
          }
        }
        data = { token: this.token, id: arrid.join(',') };
        delAdList(data).then(res => {
          this.$message(res.msg);
          this.$nextTick(() => {
            this.getGoodsList();
          });
        });
      }
    },
    startUse(num) {
      // 启动，禁用
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择后操作",
          type: "warning"
        });
      } else {
        let data = {};
        for (let i = 0; i < this.multipleSelection.length; i++) {
          let element = this.multipleSelection[i];
          data = {
            token: this.token,
            id: element.id,
            name: element.name,
            sort: element.sort,
            value: element.value,
            is_show: num.toString()
          };
          editLabel(data).then(res => {
            console.log(res);
            if (this.multipleSelection.length - 1 == i) {
              this.getlabelList();
            }
          });
        }
      }
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    // 编辑
    handleEdit(index, row) {
      this.$router.push(`editnotice?id=${row.id}`);
    },
    // 
    // 删除
    handledelet(index, row) {
      var data = {
        token: this.token,
        id: row.id
      };
      this.$confirm('确认删除该公告？').then(() => {
        delAdList(data).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.getGoodsList();
        })
      }).catch(
        console.log("取消删除")
      )
    },
    // 关闭
    closelabel(item) {
      this.showAddnotice = item;
      this.getlabelList();
    },
    closeEdit(item) {
      console.log(item);
      this.showEditlabel = false;
      this.getlabelList();
    },
  }
};
</script>
<style scoped>
.el-dropdown-link, .cell {
  cursor: pointer;
}
.paging {
  position: fixed;
  bottom: 50px;
}
td {
  padding: 12px 8px;
}
</style>

<style lang="scss" scoped>
el-table{
  height: calc(100% - 20px);
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .tableoperation {
      height: 40px;
      margin-top: 20px;
      line-height: 40px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 0;
    }
    .seach {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .el-input {
        width: 200px;
      }
    }
    .el-table {
      margin-top: 20px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      .stats {
        width: 50px;
        height: 28px;
        background: rgba(57, 125, 255, 1);
        border-radius: 2px;
        text-align: center;
        line-height: 28px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
